import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import Seo from "../seo/Seo";
import { Section, Heading, PageHero, CTASection, FAQ, faqSchema } from "../components/ui-kit";
import { IMAGES } from "../mock/mock";
import { COUNTIES, CITIES, FAQS } from "../data/site";

const CountyPage = () => {
  const { slug } = useParams();
  const data = COUNTIES.find((c) => c.slug === slug);
  if (!data) return <Navigate to="/locations" replace />;
  const breadcrumbs = [{ name: "Home", path: "/" }, { name: "Locations", path: "/locations" }, { name: data.name, path: `/locations/${data.slug}` }];
  const localFaqs = [
    { q: `Does Build Highland Homes build custom homes in ${data.name}?`, a: `Yes. Build Highland Homes designs and builds custom homes throughout ${data.name}, Florida — all built on your lot or property.` },
    ...FAQS.slice(2, 5),
  ];
  return (
    <>
      <Seo
        title={`Custom Home Builder in ${data.name}, Florida | Build Highland Homes`}
        description={`Build Highland Homes is a custom home builder in ${data.name}, Florida. We design and build custom homes on your lot throughout ${data.name}.`}
        path={`/locations/${data.slug}`}
        keywords={`custom home builder ${data.name.toLowerCase()}, custom homes ${data.name.toLowerCase()}, build a custom home ${data.name.toLowerCase()}`}
        breadcrumbs={breadcrumbs}
        schema={faqSchema(localFaqs)}
      />
      <PageHero overline={`${data.name}, Florida`} title={`Custom Home Builder in ${data.name}`} subtitle={data.intro} image={IMAGES.hero} />

      <Section className="bg-[#0b0b0b]">
        <Heading overline="Cities We Serve" title={`Custom Homes Across ${data.name}`} subtitle={`We build on your lot in communities throughout ${data.name}. Explore the cities we serve below.`} />
        <div className="flex flex-wrap justify-center gap-3">
          {data.cities.map((city) => {
            const slug = city.toLowerCase().replace(/[^a-z0-9]+/g, "-");
            return CITIES[slug]
              ? <Link key={city} to={`/locations/${slug}`} className="border border-[#c9a24b]/40 text-[#e3c77a] hover:bg-[#c9a24b] hover:text-[#0b0b0b] px-4 py-2 transition-colors">{city}</Link>
              : <span key={city} className="border border-white/10 text-[#8a857a] px-4 py-2">{city}</span>;
          })}
        </div>
      </Section>

      <Section className="bg-[#0f0f0f]">
        <Heading overline="Questions" title={`Building a Custom Home in ${data.name}`} />
        <FAQ items={localFaqs} />
      </Section>

      <CTASection title={`Build Your Custom Home in ${data.name}`} />
    </>
  );
};

export default CountyPage;
